import React from 'react'
import cx from 'classnames'
import fuzzy from 'fuzzaldrin-plus'
import css from './spaceCard.module.scss'

interface HighlightedTextProps {
  text: string
  email?: string
  query?: string
  test?: string
  className?: string
}

export default function HighlightedText({
  text,
  email,
  query,
  test,
  className,
}: HighlightedTextProps) {
  return query ? (
    <div>
      <span
        className={cx(css.space_card_space_name, className)}
        data-item={test ? test : undefined}
        dangerouslySetInnerHTML={{
          __html: fuzzy.wrap(text, query),
        }}
      />
      <div>{email}</div>
    </div>
  ) : (
    <span className={cx(css.space_card_space_name, className)} data-item={test ? test : undefined}>
      {text}
    </span>
  )
}
